import React, { useEffect, useState } from "react";
import { useCartContext } from "../context/addToCart";
import "../Css/OrderFilter.css";
import { FaCartPlus, FaTrashAlt } from "react-icons/fa";
import {
  Button,
  Divider,
  Form,
  Select,
  Radio,
  InputNumber,
  Spin,
  Empty,
  Checkbox,
  message,
} from "antd";
import { IoFilterSharp } from "react-icons/io5";
import Header from "../Components/Header";
import { getProfile } from "../services/localStorageServices";
import { useLocation, useNavigate } from "react-router-dom";
import { get, post } from "../apiService";
import DiamondCards from "../Components/AdminPanel/DiamondCards";
import { FaCheck } from "react-icons/fa6";
import Footer from "../Components/Footer";
import { MdOutlineCheckBoxOutlineBlank } from "react-icons/md";
import Excel from "../Components/Export/Excel";
import Pdf from "../Components/Export/Pdf";
import BannerComp from "../Components/BannerComp";
import { setSessionStorageItem } from "../services/sessionStorageServices";
import dimondShape from "../Assets/round-diamond-outline-removebg-preview.png";
import orderPage from "../Assets/ordersPageBanner.jpg";

const optionsData = {
  Carat: [
    { value: "0.002", label: "0.002" },
    { value: "0.003", label: "0.003" },
    { value: "0.004", label: "0.004" },
    { value: "0.005", label: "0.005" },
    { value: "0.006", label: "0.006" },
    { value: "0.0068", label: "0.0068" },
    { value: "0.0075", label: "0.0075" },
    { value: "0.0085", label: "0.0085" },
    { value: "0.0095", label: "0.0095" },
    { value: "0.011", label: "0.011" },
    { value: "0.012", label: "0.012" },
    { value: "0.013", label: "0.013" },
    { value: "0.0145", label: "0.0145" },
    { value: "0.016", label: "0.016" },
    { value: "0.018", label: "0.018" },
    { value: "0.02", label: "0.02" },
    { value: "0.025", label: "0.025" },
    { value: "0.03", label: "0.03" },
    { value: "0.035", label: "0.035" },
    { value: "0.04", label: "0.04" },
    { value: "0.045", label: "0.045" },
    { value: "0.05", label: "0.05" },
    { value: "0.055", label: "0.055" },
    { value: "0.065", label: "0.065" },
    { value: "0.074", label: "0.074" },
    { value: "0.078", label: "0.078" },
    { value: "0.086", label: "0.086" },
    { value: "0.095", label: "0.095" },
    { value: "0.108", label: "0.108" },
    { value: "0.116", label: "0.116" },
    { value: "0.125", label: "0.125" },
  ],
  Sieve: [
    { value: "00000 - 0000", label: "00000 - 0000" },
    { value: "0000 - 000", label: "0000 - 000" },
    { value: "000 - 00", label: "000 - 00" },
    { value: "00 - 0", label: "00 - 0" },
    { value: "0 - 1", label: "0 - 1" },
    { value: "1 - 1.5", label: "1 - 1.5" },
    { value: "1.5 - 2", label: "1.5 - 2" },
    { value: "2 - 2.5", label: "2 - 2.5" },
    { value: "2.5 - 3", label: "2.5 - 3" },
    { value: "3 - 3.5", label: "3 - 3.5" },
    { value: "3.5 - 4", label: "3.5 - 4" },
    { value: "4 - 4.5", label: "4 - 4.5" },
    { value: "4.5 - 5", label: "4.5 - 5" },
    { value: "5 - 5.5", label: "5 - 5.5" },
    { value: "5.5 - 6", label: "5.5 - 6" },
    { value: "6 - 6.5", label: "6 - 6.5" },
    { value: "6.5 - 7", label: "6.5 - 7" },
    { value: "7 - 7.5", label: "7 - 7.5" },
    { value: "7.5 - 8", label: "7.5 - 8" },
    { value: "8 - 8.5", label: "8 - 8.5" },
    { value: "8.5 - 9", label: "8.5 - 9" },
    { value: "9 - 9.5", label: "9 - 9.5" },
    { value: "9.5 - 10", label: "9.5 - 10" },
    { value: "10 - 10.5", label: "10 - 10.5" },
    { value: "10.5 - 11", label: "10.5 - 11" },
    { value: "11 - 11.5", label: "11 - 11.5" },
    { value: "11.5-12", label: "11.5-12" },
    { value: "12-12.5", label: "12-12.5" },
    { value: "12.5-13", label: "12.5-13" },
    { value: "13-13.5", label: "13-13.5" },
    { value: "13.5-14", label: "13.5-14" },
  ],
  "Size (mm)": [
    { value: ".70 - .80", label: ".70 - .80" },
    { value: ".80 - .90", label: ".80 - .90" },
    { value: ".90 - 1.00", label: ".90 - 1.00" },
    { value: "1.00 - 1.10", label: "1.00 - 1.10" },
    { value: "1.10 - 1.15", label: "1.10 - 1.15" },
    { value: "1.15 - 1.20", label: "1.15 - 1.20" },
    { value: "1.20 - 1.25", label: "1.20 - 1.25" },
    { value: "1.25 - 1.30", label: "1.25 - 1.30" },
    { value: "1.30 - 1.35", label: "1.30 - 1.35" },
    { value: "1.35 - 1.40", label: "1.35 - 1.40" },
    { value: "1.40 - 1.45", label: "1.40 - 1.45" },
    { value: "1.45 - 1.50", label: "1.45 - 1.50" },
    { value: "1.50 - 1.55", label: "1.50 - 1.55" },
    { value: "1.55 - 1.60", label: "1.55 - 1.60" },
    { value: "1.60 - 1.70", label: "1.60 - 1.70" },
    { value: "1.70 - 1.80", label: "1.70 - 1.80" },
    { value: "1.80 - 1.90", label: "1.80 - 1.90" },
    { value: "1.90 - 2.00", label: "1.90 - 2.00" },
    { value: "2.00 - 2.10", label: "2.00 - 2.10" },
    { value: "2.10 - 2.20", label: "2.10 - 2.20" },
    { value: "2.20 - 2.30", label: "2.20 - 2.30" },
    { value: "2.30 - 2.40", label: "2.30 - 2.40" },
    { value: "2.40 - 2.50", label: "2.40 - 2.50" },
    { value: "2.50 - 2.60", label: "2.50 - 2.60" },
    { value: "2.60 - 2.70", label: "2.60 - 2.70" },
    { value: "2.70-2.80", label: "2.70-2.80" },
    { value: "2.80-2.90", label: "2.80-2.90" },
    { value: "2.90-3.00", label: "2.90-3.00" },
    { value: "3.00-3.10", label: "3.00-3.10" },
    { value: "3.10-3.20", label: "3.10-3.20" },
    { value: "3.20-3.30", label: "3.20-3.30" },
  ],
};

const clarityData = [
  { value: "VVS", label: "VVS" },
  { value: "VS1", label: "VS1" },
  { value: "VS2", label: "VS2" },
  { value: "SI1", label: "SI1" },
  { value: "SI2", label: "SI2" },
  { value: "SI3", label: "SI3" },
  { value: "I1", label: "I1" },
  { value: "I2", label: "I2" },
  { value: "I3", label: "I3" },
  { value: "PK", label: "PK" },
  { value: "HPK", label: "HPK" },
];

const column = [
  { title: "Avg Weight", dataIndex: "avg_wt", key: "avg_wt" },
  { title: "Sieve", dataIndex: "sive_sizes", key: "sive_sizes" },
  { title: "Size (MM)", dataIndex: "diam_mm", key: "diam_mm" },
  { title: "Color	", dataIndex: "color", key: "color" },
  { title: "Shade	", dataIndex: "shade", key: "shade" },
  { title: "Cut", dataIndex: "cut", key: "cut" },
  { title: "Clarity", dataIndex: "clarity", key: "clarity" },
  { title: "Price", dataIndex: "price", key: "price" },
  // { title: "Type", dataIndex: "typeSelect", key: "typeSelect" },
  // { title: "Selected Type", dataIndex: "updatedData", key: "updatedData" },
  { title: "Total Weight", dataIndex: "total_weight", key: "total_weight" },
  { title: "Value", dataIndex: "updatedPrice", key: "updatedPrice" },
];

const OrderFilter = () => {
  const navigate = useNavigate();
  const { profile } = getProfile();
  const { handleAddCart, cartValue, setCartValue } = useCartContext();
  const [colorShades, setColorShades] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedType, setSelectedType] = useState("Carat"); // Default to 'Carat'
  const [caratSeiveMm, setCaratSeiveMm] = useState([]);
  const [spinLoading, setSpinLoading] = useState(false);
  const [loadings, setLoadings] = useState([false, false]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [active, setActive] = useState(false);
  const [form] = Form.useForm();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    limit: 100,
  });
  const [checkList, setCheckList] = useState([]);

  const [orderSubTotal, setOrderSubTotal] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);

  useEffect(() => {
    // dispatch(setUserToken({ token: access_token }));
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line
  }, []);

  const [dataList, setDataList] = useState([]);
  useEffect(() => {
    if (!profile || profile.verify == "0") {
      navigate("/");
    }
    // eslint-disable-next-line
  }, []);

  const colorShadeOptions = {
    FG: [{ value: "White", label: "White" }],
    HIJ: [
      { value: "Yellow", label: "Yellow" },
      { value: "Brown", label: "Brown" },
    ],
  };

  useEffect(() => {
    const shades = colorShadeOptions[selectedColor] || [];
    setColorShades(shades);

    // Automatically select the first option as default in colorShade
    if (shades.length > 0) {
      form.setFieldsValue({ colorShade: shades[0].value }); // Set default value to first option
    } else {
      form.setFieldsValue({ colorShade: undefined }); // Clear the value if no options are available
    }
    // eslint-disable-next-line
  }, [selectedColor]);

  const onFinish = (values) => {
    // Capture form values
    const formData = form.getFieldsValue();
    // Create a slug from form values (URLSearchParams is useful for query params)
    const params = new URLSearchParams();
    Object.entries(formData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        params.append(key, value.join(",")); // Join array values as comma-separated strings
      } else {
        params.append(key, value);
      }
    });

    // Convert params to string (slug)
    const queryString = params.toString();

    // Navigate to new route with query parameters
    navigate(`/search?${queryString}`);
    setActive(false);
  };

  const location = useLocation();

  // Extract query parameters when the component mounts
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const caratSieveSize = params.get("caratSieveSize");
    const color = params.get("color");
    const clarity = params.get("clarity");
    const cut = params.get("cut");
    const colorShade = params.get("colorShade");
    const type = params.get("type");
    const typeColor = params.get("colorShade");

    // Only proceed if query string exists
    if (location.search) {
      // Check if form fields are empty before setting values
      const currentFormValues = form.getFieldsValue();
      if (!currentFormValues.caratSieveSize && caratSieveSize) {
        form.setFieldsValue({ caratSieveSize: caratSieveSize.split(",") });
      }
      if (!currentFormValues.color && color) {
        form.setFieldsValue({ color });
      }
      if (!currentFormValues.clarity && clarity) {
        form.setFieldsValue({ clarity: clarity.split(",") });
      }
      if (!currentFormValues.cut && cut) {
        form.setFieldsValue({ cut });
      }
      if (!currentFormValues.colorShade && colorShade) {
        form.setFieldsValue({ colorShade });
      }
      if (!currentFormValues.type && type) {
        form.setFieldsValue({ type });
      }
  
      const dbounce = setTimeout(() => {
        // Call the API with FormData using these parameters
        fetchSearchResults({
          caratSieveSize,
          color,
          clarity,
          cut,
          colorShade,
          type,
          typeColor
        });
      }, 300);

      return () => clearTimeout(dbounce);
    }
    // eslint-disable-next-line
  }, [location.search, pagination.limit]);

  // Function to fetch search results using FormData and API call
  const fetchSearchResults = async ({
    caratSieveSize,
    color,
    clarity,
    cut,
    colorShade,
    type,
    typeColor
  }) => {
    try {
      const action = "fetchFilter";
      const limit = pagination.limit;
      const page = pagination.current;
      let search;

      switch (type) {
        case "Carat":
          search = "avg_wt";
          break;
        case "Sieve":
          search = "sive_sizes";
          break;
        case "Size (mm)":
          search = "diam_mm";
          break;
        default:
          search = "avg_wt";
          break;
      }
      // Simulate fetching data from an API
      const response = await get(
        `/product.php?action=${action}&limit=${limit}&page=${page}&type=${color}&typeColor=${typeColor}&priceType=${clarity}&${search}=${caratSieveSize}`
      );

      const responseData = await response;
      // Process response data (format it according to your needs)
      const formattedData = responseData.list?.map((v, i) => ({
        ...v,
        index: i,
        key: v.product_id + i,
        sieve: v.sive_sizes,
        mm: v.diam_mm,
        avgWeight: v.avg_wt,
        color: v.type,
        shade: colorShade,
        cut: cut,
        price:
          cut === "Excellent" ? parseFloat(v.price) + 15 : parseFloat(v.price),
        clarity: v.priceType,
        total_weight:
          parseFloat(v.caratValue).toFixed(2) >= 0.01
            ? parseFloat(v.caratValue).toFixed(2)
            : 0.01,
        updatedPrice: (
          (cut === "Excellent"
            ? parseFloat(v.price) + 15
            : parseFloat(v.price)) *
          (parseFloat(v.caratValue).toFixed(2) >= 0.01
            ? parseFloat(v.caratValue).toFixed(2)
            : 0.01)
        ).toFixed(2),
        updatePice:
          parseFloat(v.caratValue).toFixed(2) >= 0.01
            ? v.picesValue
            : parseInt(0.01 / v.avg_wt).toFixed(1),
        minimumPice:
          parseFloat(v.caratValue).toFixed(2) >= 0.01
            ? v.picesValue
            : parseInt(0.01 / v.avg_wt).toFixed(1),
        updateCarat:
          parseFloat(v.caratValue).toFixed(2) >= 0.01
            ? parseFloat(v.caratValue).toFixed(2)
            : 0.01,
        minimumCarat:
          parseFloat(v.caratValue).toFixed(2) >= 0.01
            ? parseFloat(v.caratValue).toFixed(2)
            : 0.01,
        typeSelect: "Carat",
      }));

      setDataList(formattedData); // Set the formatted data to state
      setSpinLoading(false); // Stop spinner loading state

      // Set button loading to false
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[1] = false;
        return newLoadings;
      });
      setPagination((prev) => ({ ...prev, total: responseData.total }));
    } catch (error) {
      console.error("Error fetching search results:", error);
      setSpinLoading(false);
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[1] = false;
        return newLoadings;
      });
    }
  };

  useEffect(() => {
    // Calculate order subtotal
    let subtotal = 0;
    let total_weight = 0;

    dataList.forEach((element) => {
      subtotal += parseFloat(element.updatedPrice); // Accumulate subtotal as a number
    });

    dataList.forEach((element) => {
      total_weight += parseFloat(element.total_weight); // Accumulate subtotal as a number
    });

    total_weight = parseFloat(total_weight).toFixed(2);
    subtotal = parseFloat(subtotal).toFixed(2);

    // Update state
    setTotalWeight(total_weight);
    setOrderSubTotal(subtotal);
  }, [dataList]);

  const handleSave = async (row, index) => {
    const formData = new FormData();
    formData.append("product_type", row.typeSelect);
    formData.append(
      "selected_type",
      row.typeSelect === "Carat" ? row.updateCarat : row.updatePice
    );
    formData.append("color", row.color);
    formData.append("shade", row.shade);
    formData.append("clarity", row.clarity);
    formData.append("cut", row.cut);
    formData.append("status", "cart");
    formData.append("type", "cart");
    formData.append("product_id", row.product_id);
    formData.append("price", row.price);
    formData.append("total_weight", row.total_weight);
    formData.append("user_id", profile.user_id);
    formData.append("subtotal", row.updatedPrice);
    formData.append("action", "add");
    try {
      const response = await post(`/cart.php`, formData);
      if (response) {
        const cartItem = {
          ...row,
          selected_type:
            row.typeSelect === "Carat" ? row.updateCarat : row.updatePice,
          product_type: row.typeSelect,
          subtotal: row.updatedPrice,
          cart_id: response.message.id,
        };
        handleAddCart(cartItem);
      }
    } catch (error) {
      console.log("error adding product to cart", error);
    }
  };

  // On type change, update the options
  useEffect(() => {
    setCaratSeiveMm(optionsData[selectedType] || []);
    // eslint-disable-next-line
  }, [selectedType]);

  // Handle change
  const handleChange = (value) => {
    setSelectedValues(value); // Update selected values
  };

  const customDropdown = (menu) => {
    return <div>{menu}</div>;
  };

  function getNotCommonData(array1, array2) {
    const arrayData = array1.filter(
      (valueCheck) =>
        !array2.some(
          (v) =>
            valueCheck.product_id === v.product_id &&
            valueCheck.sive_sizes === v.sive_sizes &&
            valueCheck.diam_mm === v.diam_mm &&
            valueCheck.avg_wt === v.avg_wt &&
            valueCheck.color === v.color &&
            valueCheck.shade === v.shade &&
            valueCheck.cut === v.cut &&
            valueCheck.clarity === v.clarity &&
            valueCheck.typeSelect === v.typeSelect &&
            valueCheck.updateCarat === v.updateCarat &&
            valueCheck.updatePice === v.updatePice
        )
    );

    return arrayData;
  }

  const isItemInList = (list, item) =>
    list.some(
      (valueCheck) =>
        valueCheck.product_id === item.product_id &&
        valueCheck.sive_sizes === item.sive_sizes &&
        valueCheck.diam_mm === item.diam_mm &&
        valueCheck.avg_wt === item.avg_wt &&
        valueCheck.color === item.color &&
        valueCheck.shade === item.shade &&
        valueCheck.cut === item.cut &&
        valueCheck.clarity === item.clarity &&
        valueCheck.typeSelect === item.typeSelect &&
        (valueCheck.updateCarat === item.updateCarat ||
          valueCheck.updatePice === item.updatePice)
    );

  // Update function to handle adding/removing items in checkList
  const toggleCheckList = (item) => {
    setCheckList((prev) => {
      if (isItemInList(prev, item)) {
        // Remove item if it already exists
        return prev.filter(
          (valueCheck) =>
            !(
              valueCheck.product_id === item.product_id &&
              valueCheck.sive_sizes === item.sive_sizes &&
              valueCheck.diam_mm === item.diam_mm &&
              valueCheck.avg_wt === item.avg_wt &&
              valueCheck.color === item.color &&
              valueCheck.shade === item.shade &&
              valueCheck.cut === item.cut &&
              valueCheck.clarity === item.clarity &&
              valueCheck.typeSelect === item.typeSelect &&
              (valueCheck.updateCarat === item.updateCarat ||
                valueCheck.updatePice === item.updatePice)
            )
        );
      } else {
        // Add item if it doesn't exist
        return [...prev, item];
      }
    });
  };

  const handleAllAddCart = async () => {
    if (checkList.length > 0) {
      try {
        const cartAddData = getNotCommonData(checkList, cartValue);
        const updatedData = cartAddData.map((val, index) => ({
          ...val,
          cartId: "cart" + index,
          selected_type:
            val.typeSelect === "Carat" ? val.updateCarat : val.updatePice,
          product_type: val.typeSelect,
          subtotal: val.updatedPrice,
        }));

        const formData = new FormData();
        formData.append("status", "cart");
        formData.append("type", "cart");
        formData.append("user_id", profile.user_id);
        formData.append("cartData", JSON.stringify(updatedData));
        formData.append("action", "addMultipule");

        const response = await post(`/cart.php`, formData);
        if (response) {
          const newData = updatedData.map((val, i) => ({
            ...val,
            selected_type:
              val.typeSelect === "Carat" ? val.updateCarat : val.updatePice,
            product_type: val.typeSelect,
            subtotal: val.updatedPrice,
            cart_id: response?.message?.data["cart" + i],
          }));

          const allData = [...cartValue, ...newData];
          setCartValue(allData);
          setSessionStorageItem("cart", allData);
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      message.error("No Data Selected");
    }
  };

  const handleRemoveFromCart = async (value) => {
    const index = cartValue.findIndex(
      (valueData) => value[0].cart_id === valueData.cart_id
    );
    const cart_id = value[0].cart_id;

    try {
      if (window.confirm("Are you sure you want to remove from cart")) {
        try {
          const formData = new FormData();
          formData.append("action", "remove");
          formData.append("cart_id", cart_id);
          const response = await post("/cart.php", formData);
          if (response) {
            const prevData = [...cartValue];
            prevData.splice(index, 1);
            setCartValue(prevData);
            // setCartItems(prevData);
            if (prevData.length === 0) {
              sessionStorage.clear();
            } else {
              setSessionStorageItem("cart", prevData);
            }
          }
        } catch (error) {
          console.log("error deleted cart from add to cart");
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Header />
      <BannerComp
        title="Search Diamonds"
        breadcrumb={[
          {
            title: "Home",
            href: "/",
          },
          {
            title: "Order",
          },
        ]}
        image={orderPage}
      />

      <section className="orderFilter-sec-main">
        <div className={isMobile ? "container" : "container-fluid px-xl-4"}>
          <div className="orderFilter-first-div">
            <div className="row">
              <div className="col-lg-3">
                <div
                  className={`bgActive ${active && "active"}`}
                  onClick={() => setActive(false)}
                ></div>
                <div
                  className={`orderFilter-right-col-shape-round ${
                    active && "active"
                  }`}
                >
                  <div className="text-center">
                    <div className="mb-2"> Shape</div>
                    <div className="">
                      <img
                        alt="Diamond Search"
                        className="orderFilter-daimond-img-round"
                        src={dimondShape}
                      />
                    </div>
                    <div className="">Round</div>
                  </div>
                  <div className="">
                    <Form
                      form={form}
                      layout="vertical"
                      name="registration"
                      autoComplete="off"
                      initialValues={{ remember: true }}
                      onFinish={onFinish}
                    >
                      <div className=" align-items-baseline pt-4 ">
                        <Form.Item name="type">
                          <Radio.Group
                            className="d-flex justify-content-center mb-3"
                            onChange={(e) => {
                              setSelectedType(e.target.value);
                              form.setFieldsValue({ caratSieveSize: [] });
                            }}
                            value={selectedType}
                          >
                            <Radio value="Carat"> Carat</Radio>
                            <Radio value="Sieve">Sieve</Radio>
                            <Radio value="Size (mm)">Size (mm)</Radio>
                          </Radio.Group>
                        </Form.Item>
                        <label className="d-block w-100">
                          <Form.Item
                            name="caratSieveSize"
                            rules={[
                              {
                                required: true,
                                message: "This field is required.",
                              },
                            ]}
                          >
                            <Select
                              mode="multiple"
                              allowClear
                              onChange={handleChange}
                              dropdownRender={customDropdown}
                              name="caratSieveSize"
                              options={caratSeiveMm?.map((option) => ({
                                value: option.value,
                                label: (
                                  <span
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {option.label}
                                    {selectedValues.includes(option.value) ? (
                                      ""
                                    ) : (
                                      <MdOutlineCheckBoxOutlineBlank
                                        style={{ fontSize: "1.1rem" }}
                                      />
                                    )}
                                  </span>
                                ),
                              }))}
                              style={{ marginBottom: "none" }}
                              className="caratSieveSize-radio-select-box"
                              value={selectedValues} // Set selected values
                            />
                          </Form.Item>
                        </label>
                      </div>
                      <div className="row">
                        <div className="col-lg-6 col-md-6 justify-content-center align-items-center">
                          <label>Color:</label>
                          <label className="orderFilter-select-label w-100">
                            <Form.Item
                              name="color"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required.",
                                },
                              ]}
                            >
                              <Select
                                name="color"
                                onChange={(value) => setSelectedColor(value)}
                                options={[
                                  { value: "FG", label: "FG" },
                                  { value: "HIJ", label: "HIJ" },
                                ]}
                              />
                            </Form.Item>
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 justify-content-center align-items-center">
                          <label>Color Shade:</label>
                          <label className="orderFilter-select-label w-100">
                            <Form.Item
                              name="colorShade"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required.",
                                },
                              ]}
                            >
                              <Select
                                name="colorShade"
                                onChange={handleChange}
                                options={colorShades}
                              />
                            </Form.Item>
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 justify-content-center align-items-center">
                          <label>Clarity:</label>
                          <label className="w-100">
                            <Form.Item
                              name="clarity"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required.",
                                },
                              ]}
                            >
                              <Select
                                mode="multiple"
                                allowClear
                                name="clarity"
                                onChange={handleChange}
                                options={clarityData?.map((option) => ({
                                  value: option.value,
                                  label: (
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {option.label}
                                      {selectedValues.includes(option.value) ? (
                                        ""
                                      ) : (
                                        <MdOutlineCheckBoxOutlineBlank
                                          style={{ fontSize: "1.1rem" }}
                                        />
                                      )}
                                    </span>
                                  ),
                                }))}
                                style={{ marginBottom: "none" }}
                              />
                            </Form.Item>
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 justify-content-center align-items-baseline">
                          <label>Cut:</label>
                          <label className="orderFilter-select-label w-100">
                            <Form.Item
                              name="cut"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required.",
                                },
                              ]}
                            >
                              <Select
                                onChange={handleChange}
                                name="cut"
                                options={[
                                  { value: "Excellent", label: "Excellent" },
                                  { value: "Very Good", label: "Very Good" },
                                ]}
                              />
                            </Form.Item>
                          </label>
                        </div>
                        <div className="orderFilter-search-btn">
                          {/* <Button
                            className="orderFilter-serach-btn d-block d-md-none w-100 bg-danger text-white"
                            htmlType="submit"
                            loading={loadings[1]}
                            onClick={() => setActive(false)}
                          >
                            Cancel
                          </Button> */}
                          <Button
                            className="bg-danger text-white w-50"
                            onClick={() => {
                              setActive(false);
                              navigate("/search");
                              form.resetFields();
                              setDataList([]);
                            }}
                          >
                            Clear
                          </Button>
                          <Button
                            className="orderFilter-serach-btn w-50"
                            htmlType="submit"
                            loading={loadings[1]}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
              <div className="col-lg-9 col-md-12">
                <div className="orderFilter-all-search-result-table">
                  <div className="px-3 mb-sm-3 orderFilter-result-all-show-export">
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className="pt-3 orderFilter-result-limited-heading-tag">
                        <strong className="orderFilter-result-text">
                          Result
                        </strong>
                        &nbsp;-&nbsp;All prices listed are in US dollars
                      </h5>
                      <Button
                        className="d-block d-lg-none"
                        icon={<IoFilterSharp />}
                        style={{
                          borderRadius: "0",
                          minHeight: "40px",
                          color: "#fff",
                          backgroundColor: "#003754",
                        }}
                        onClick={() => setActive(true)}
                      >
                        &nbsp;Search Diamonds
                      </Button>
                    </div>
                    <Divider orientation="center">
                      Total Data ({pagination.total})
                    </Divider>
                    <div className="row justify-content-between align-items-center">
                      <div className="col-md-6 col-sm-7 order-sm-1 order-2  order-md-1 orderFilter-show-entries text-muted d-flex align-items-center justify-content-between mb-3 mb-sm-0 justify-content-sm-start">
                        <Checkbox
                          className="d-flex d-md-none"
                          style={{
                            boxShadow: "0 0 2px #808080",
                            background: "#fff",
                            padding: "8px",
                            borderRadius: "5px",
                          }}
                          checked={checkList.length > 0}
                          onChange={() =>
                            checkList.length > 0
                              ? setCheckList([])
                              : setCheckList(dataList)
                          }
                        >
                          Check All
                        </Checkbox>
                        <Button
                          className="bg-dark text-white mx-2"
                          icon={<FaCartPlus />}
                          style={{ height: 40 }}
                          onClick={handleAllAddCart}
                        >
                          Add Cart
                        </Button>
                      </div>
                      <div className="col-md-6 col-sm-5 order-sm-2 order-1 text-muted orderFilter-show-entries-export d-flex align-items-center justify-content-between justify-content-sm-end py-3">
                        <Pdf
                          column={column}
                          data={
                            dataList.length > 0
                              ? [
                                  ...dataList.map((val) => ({
                                    ...val,
                                    total_weight: val.total_weight,
                                    updatedData:
                                      val.typeSelect === "Carat"
                                        ? val.updateCarat
                                        : val.updatePice,
                                  })),
                                  {
                                    price: "Total",
                                    total_weight: totalWeight,
                                    updatedPrice: orderSubTotal,
                                  },
                                ]
                              : []
                          }
                          fileName="sejal_dimonds_product"
                        />
                        &nbsp;
                        <Excel
                          column={column}
                          data={
                            dataList.length > 0
                              ? [
                                  ...dataList.map((val) => ({
                                    ...val,
                                    total_weight: val.total_weight,
                                    updatedData:
                                      val.typeSelect === "Carat"
                                        ? val.updateCarat
                                        : val.updatePice,
                                  })),
                                  {
                                    price: "Total",
                                    total_weight: totalWeight,
                                    updatedPrice: orderSubTotal,
                                  },
                                ]
                              : []
                          }
                          fileName="sejal_diamonds_product"
                        />
                      </div>
                    </div>
                  </div>

                  <Spin spinning={spinLoading}>
                    <div className="table-container">
                      {dataList && dataList.length > 0 ? (
                        <table>
                          <tr className="orderFilter-tr-th">
                            <th>
                              <Checkbox
                                checked={checkList.length > 0}
                                onChange={() =>
                                  checkList.length > 0
                                    ? setCheckList([])
                                    : setCheckList(dataList)
                                }
                              />
                            </th>
                            <th>Sr&nbsp;No.</th>
                            <th width="10%">Avg&nbsp;Weight</th>
                            <th className="orderFilter-th" width="20%">
                              Sieve
                            </th>
                            <th width="10%">Size(MM)</th>
                            <th width="5%">Color</th>
                            <th width="7%">Shade </th>
                            <th width="10%">Cut </th>
                            <th width="10%">Clarity</th>
                            <th width="10%">Price</th>
                            <th>Type </th>
                            <th>Selected&nbsp;Type</th>
                            <th>Total&nbsp;Weight </th>
                            <th>Subtotal </th>
                            <th>Action </th>
                          </tr>

                          {dataList?.map((v, i) => (
                            <tr className="orderFilter-tr-td">
                              <td>
                                <Checkbox
                                  checked={
                                    isItemInList(cartValue, v) ||
                                    isItemInList(checkList, v)
                                  }
                                  onChange={() => toggleCheckList(v)}
                                  disabled={isItemInList(cartValue, v)}
                                />
                              </td>
                              <td style={{ fontSize: ".9rem" }}>
                                <strong>
                                  {i + 1 < 10 ? "0" + (i + 1) : i + 1}
                                </strong>
                              </td>
                              <td style={{ fontSize: ".9rem" }}>{v.avg_wt} </td>
                              <td style={{ fontSize: ".9rem" }}>
                                {v.sive_sizes}
                              </td>
                              <td style={{ fontSize: ".9rem" }}>{v.diam_mm}</td>
                              <td style={{ fontSize: ".9rem" }}>{v.type} </td>
                              <td style={{ fontSize: ".9rem" }}>{v.shade} </td>
                              <td style={{ fontSize: ".9rem" }}>{v.cut} </td>
                              <td style={{ fontSize: ".9rem" }}>
                                {v.priceType}
                              </td>
                              <td style={{ fontSize: ".9rem" }}>
                                $&nbsp;{v.price}
                              </td>
                              <td style={{ fontSize: ".9rem" }}>
                                <Select
                                  style={{ width: "100%", maxWidth: "100px" }}
                                  placeholder="Type"
                                  onSelect={(val) =>
                                    setDataList((prev) => {
                                      const updatedDataList = [...prev];
                                      updatedDataList[i] = {
                                        ...updatedDataList[i],
                                        typeSelect: val,
                                        total_weight: parseFloat(
                                          val === "Carat"
                                            ? updatedDataList[i].caratValue
                                            : updatedDataList[i].updatePice *
                                                updatedDataList[i].avg_wt
                                        ).toFixed(2),
                                        updatedPrice:
                                          val === "Carat"
                                            ? parseFloat(
                                                updatedDataList[i].updateCarat *
                                                  updatedDataList[i].price
                                                //   : 0)
                                              ).toFixed(2)
                                            : (
                                                parseFloat(
                                                  updatedDataList[i].avg_wt *
                                                    updatedDataList[i]
                                                      .updatePice
                                                ) * updatedDataList[i].price
                                              ).toFixed(2),
                                      };
                                      return updatedDataList;
                                    })
                                  }
                                  value={v.typeSelect}
                                >
                                  <Select.Option value="Carat">
                                    Carat
                                  </Select.Option>
                                  <Select.Option value="Piece">
                                    Piece
                                  </Select.Option>
                                </Select>
                              </td>

                              <td>
                                {v.typeSelect === "Carat" ? (
                                  <>
                                    <InputNumber
                                      style={{
                                        minHeight: 33,
                                        maxWidth: "100px",
                                        borderColor:
                                          parseFloat(v.updateCarat) > 10
                                            ? "red"
                                            : "#afafaf",
                                      }}
                                      pattern="^\d*\.?\d*$"
                                      step={0.1}
                                      min={v.minimumCarat}
                                      value={v.updateCarat}
                                      onChange={(val) =>
                                        setDataList((prev) => {
                                          const updatedDataList = [...prev];
                                          updatedDataList[i] = {
                                            ...updatedDataList[i],
                                            updateCarat:
                                              parseFloat(val).toFixed(2),
                                            total_weight:
                                              parseFloat(val).toFixed(2),
                                            updatedPrice: (
                                              parseFloat(val).toFixed(2) *
                                              v.price
                                            ).toFixed(2),
                                          };
                                          return updatedDataList;
                                        })
                                      }
                                    />
                                    <br />
                                    {parseFloat(v.updateCarat) > 10 && (
                                      <span
                                        style={{
                                          color: "red",
                                          fontSize: ".75rem",
                                        }}
                                      >
                                        Max 10 Carat
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <InputNumber
                                      style={{
                                        minHeight: 33,
                                        maxWidth: "100px",
                                      }}
                                      pattern="^\d*\.?\d*$"
                                      value={v.updatePice}
                                      step={10}
                                      min={v.minimumPice}
                                      onChange={(valu) =>
                                        setDataList((prev) => {
                                          const updatedDataList = [...prev];
                                          updatedDataList[i] = {
                                            ...updatedDataList[i],
                                            updatePice: valu,
                                            total_weight: parseFloat(
                                              valu * v.avg_wt
                                            ).toFixed(2),
                                            updatedPrice: (
                                              valu *
                                              v.avg_wt *
                                              v.price
                                            )
                                              // +
                                              // (updatedDataList[i].cut ===
                                              // "Excellent"
                                              //   ? 15
                                              //   : 0)
                                              .toFixed(2),
                                          };
                                          return updatedDataList;
                                        })
                                      }
                                    />
                                    {parseFloat(
                                      v.updatePice * v.avg_wt
                                    ).toFixed(2) > 10 && (
                                      <span
                                        style={{
                                          color: "red",
                                          fontSize: ".75rem",
                                        }}
                                      >
                                        Max 10 Carat
                                      </span>
                                    )}
                                  </>
                                )}
                              </td>
                              <td
                                style={{
                                  fontSize: ".9rem",
                                  textAlign: "center",
                                }}
                              >
                                {v.total_weight}
                              </td>
                              <td style={{ fontSize: ".9rem" }}>
                                $&nbsp;{v.updatedPrice}
                              </td>

                              <td style={{ fontSize: ".9rem" }}>
                                {cartValue.some(
                                  (valueCheck) =>
                                    valueCheck.product_id === v.product_id &&
                                    valueCheck.sive_sizes === v.sive_sizes &&
                                    valueCheck.diam_mm === v.diam_mm &&
                                    valueCheck.avg_wt === v.avg_wt &&
                                    valueCheck.color === v.color &&
                                    valueCheck.shade === v.shade &&
                                    valueCheck.cut === v.cut &&
                                    valueCheck.clarity === v.clarity &&
                                    valueCheck.typeSelect === v.typeSelect &&
                                    (valueCheck.updateCarat === v.updateCarat ||
                                      valueCheck.updatePice === v.updatePice)
                                ) ? (
                                  <div className="d-flex">
                                    <Button
                                      className=""
                                      type="link"
                                      style={{
                                        backgroundColor: "green",
                                        marginRight: "5px",
                                      }}
                                    >
                                      <FaCheck className="orderFilter-add-to-cart-btn-icon" />
                                    </Button>
                                    <Button
                                      className="bg-danger text-white"
                                      type="link"
                                      onClick={() =>
                                        handleRemoveFromCart(
                                          cartValue.map((valueCheck) =>
                                            valueCheck.product_id ===
                                              v.product_id &&
                                            valueCheck.sive_sizes ===
                                              v.sive_sizes &&
                                            valueCheck.diam_mm === v.diam_mm &&
                                            valueCheck.avg_wt === v.avg_wt &&
                                            valueCheck.color === v.color &&
                                            valueCheck.shade === v.shade &&
                                            valueCheck.cut === v.cut &&
                                            valueCheck.clarity === v.clarity &&
                                            valueCheck.typeSelect ===
                                              v.typeSelect &&
                                            (valueCheck.updateCarat ===
                                              v.updateCarat ||
                                              valueCheck.updatePice ===
                                                v.updatePice)
                                              ? valueCheck
                                              : null
                                          )
                                        )
                                      }
                                      // style={{ backgroundColor: "green" }}
                                    >
                                      <FaTrashAlt className="orderFilter-add-to-cart-btn-icon" />
                                    </Button>
                                  </div>
                                ) : parseFloat(v.updateCarat) > 10 ? (
                                  <Button
                                    className=""
                                    type="link"
                                    style={{ backgroundColor: "red" }}
                                    onClick={() => handleSave(v, i)}
                                    disabled
                                  >
                                    <FaCartPlus className="orderFilter-add-to-cart-btn-icon" />
                                  </Button>
                                ) : (
                                  <Button
                                    className="orderFilter-add-to-cart orderFilter-add-to-cart-icon-btn-button"
                                    type="link"
                                    onClick={() => handleSave(v, i)}
                                  >
                                    <FaCartPlus className="orderFilter-add-to-cart-btn-icon" />
                                  </Button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </table>
                      ) : (
                        <div className="d-flex justify-content-center w-100">
                          <Empty
                            style={{ fontSize: "1.2rem", width: "100%" }}
                          />
                        </div>
                      )}
                    </div>
                    <div className="oder-filter-add-tocard-card">
                      <DiamondCards
                        toggleCheckList={toggleCheckList}
                        isItemInList={isItemInList}
                        checkList={checkList}
                        dataList={dataList}
                        handleDiscount=""
                        handleSave={handleSave}
                        setDataList={setDataList}
                        setUpsDownDiscount=""
                        upsDownDiscount=""
                        cartValue={cartValue}
                        handleRemoveFromCart={handleRemoveFromCart}
                      />
                    </div>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default OrderFilter;
